import { useEffect } from 'react';
import Cookies from 'universal-cookie';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../store';
import { addUserSessionTrigger } from '../../slices/authSlice';

const Logout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const cookies = new Cookies();
  useEffect(() => {
    const performLogout = async () => {
      try {
        await dispatch(addUserSessionTrigger());
        localStorage.removeItem('menuName');
        const allCookies = cookies.getAll();

        for (const cookieName in allCookies) {
          cookies.remove(cookieName, { path: '/' });
        }

        navigate('/');
      } catch (error) {
        console.error('Error during logout:', error);
      }
    };

    performLogout();
  }, []);
  return null;
};

export default Logout;
